import Rx from 'rxjs';
import { fromJS } from 'immutable';
import { combineEpics } from 'redux-observable';
import { push } from 'react-router-redux';

import { request } from 'core/generalFunctions';
import * as generalActions from 'modules/general/action';
import * as errorActions from 'modules/error/action';
import * as gruposSolicitudesActions from './action';
import * as actionConstants from 'root/actionConstants';

const { ajax } = Rx.Observable;

export const gruposSolicitudesGetEpic = (action$, store) =>
  action$.ofType(actionConstants.GRUPOS_SOLICITUDES_GET).switchMap(action =>
    ajax(request(action))
      .switchMap(({ response }) => {
        if (Array.isArray(response)) {
          let stateToSet = {};
          if (response.length > 0)
            stateToSet = {
              scrollControl: { hasMore: true, page: action.payload.skip / 100 + 1, fecha: action.payload.fecha },
              lista: store
                .getState()
                .getIn(['gruposSolicitudes', 'lista'])
                .concat(fromJS(response)),
            };
          else stateToSet.scrollControl = { hasMore: false, page: 0, fecha: new Date() };

          return Rx.Observable.of(gruposSolicitudesActions.setState(stateToSet));
        }
        return Rx.Observable.empty();
      })
      .catch(err => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const gruposSolicitudesCuantosHayEpic = (action$, store) =>
  action$.ofType(actionConstants.GRUPOS_SOLICITUDES_CUANTOS_HAY).switchMap(action =>
    ajax(request(action))
      .switchMap(({ response }) => {
        if (response) return Rx.Observable.of(gruposSolicitudesActions.setState({ cuantosHay: response }));
        return Rx.Observable.empty();
      })
      .catch(err => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const gruposSolicitudesAceptarSeleccionadosEpic = (action$, store) =>
  action$.ofType(actionConstants.GRUPOS_SOLICITUDES_ACEPTAR_SELECCIONADAS).switchMap(action =>
    ajax(request(action))
      .map(() => gruposSolicitudesActions.clear('list'))
      .concat(Rx.Observable.of(gruposSolicitudesActions.seleccionarTodas(false)))
      .concat(Rx.Observable.of(generalActions.snackbar_show(action.payload.aceptada ? 'Solicitudes aceptadas' : 'Solicitudes denegadas')))
      .concat(Rx.Observable.of(gruposSolicitudesActions.getGruposSolicitudes()))
      .concat(Rx.Observable.of(gruposSolicitudesActions.getCantidadGruposSolicitudes()))
      .catch(err => errorActions.request(err, action))
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export default combineEpics(gruposSolicitudesGetEpic, gruposSolicitudesAceptarSeleccionadosEpic, gruposSolicitudesCuantosHayEpic);



// WEBPACK FOOTER //
// src/modules/gruposSolicitudes/epics.js